// removed by extract-text-webpack-plugin
module.exports = {"icon":"_3am-1qeqWrvcfdBxmmGkg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/styles.css
// module id = 294
// module chunks = 0